import { Component } from '@angular/core';
import { NavParams, ViewController, ModalController, AlertController } from 'ionic-angular';

import { GestaoPcaService } from "../../../providers/gestao-pca-service";

/*
  Generated class for the ModalAdicionarPergunta page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-modal-retificacao',
    templateUrl: 'modal-retificacao.html'
})
export class ModalRetificacaoPage {

    retificacao: any = {
        "idSaneamento": 0,
        "descricao": "",
        "modulos": [],
        "idPca": 0,
        "modulosAnalise": [],
        "arquivos": false
    };

    titulo: any;
    PCAAtiva: any;
    listaModulos: any = [];
    listaSubModulos: any = [];
    idSaneamento: any = 0;
    comboModulos: any = [];
    comboSubModulos: any = [];
    isJurisdicionado: any;
    loading: any = true;
    loadingSub: any = false;

    objetoRetorno: any = {
        salvar: false,
        periodoFuncao: ''
    };

    constructor(private viewCtrl: ViewController,
        public modalCtrl: ModalController,
        public gestaoPcaService: GestaoPcaService,
        public alertCtrl: AlertController,
        public navParams: NavParams) {

        this.titulo = this.navParams.get('titulo');

        this.objetoRetorno = {
            flag: false
        };

        this.PCAAtiva = this.navParams.get('pca');
        this.isJurisdicionado = this.navParams.get('jurisdicionado');
        this.idSaneamento = this.PCAAtiva.saneamento.idSaneamento;

        this.carregarModulos();
        this.carregarRetificacao();
    }

    carregarRetificacao() {
        if (this.idSaneamento) {

            this.loading = true;

            this.gestaoPcaService.obterRetificacao(this.idSaneamento).subscribe(data => {
                this.retificacao = data;

                this.gestaoPcaService.listarModuloPorModuloPcaPorPCA(this.PCAAtiva.id).subscribe(mod => {
                    this.comboModulos = mod;

                    this.onModuloClose();

                    this.comboSubModulos = this.retificacao.modulosAnalise;
                
                }, error => {
                    console.log("erro: " + error);
                });
            }, error => {
                console.log("erro: " + error);
            });
        }
    }

    carregarModulos() {
        this.gestaoPcaService.obterModulosPorPCAJurisdicionado(this.PCAAtiva.id).subscribe(data => {
            this.listaModulos = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
        });
    }

    carregarRegras(codModulo) {
        this.loadingSub = true;
        this.gestaoPcaService.obterListaModuloAnalise(codModulo, this.PCAAtiva.id).subscribe(data => {
            this.listaSubModulos = data.filter(moduloAnalise => moduloAnalise.codJurisdicionado == 0 || moduloAnalise.codJurisdicionado == 2);
            this.loadingSub = false;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loadingSub = false;
            this.loading = false;
        });
    }

    enviar() {
        if (this.retificacao.descricao != '') {

            this.loading = true;

            let retificacaoNova = {
                "idSaneamento": this.idSaneamento,
                "descricao": this.retificacao.descricao,
                "modulos": this.retificacao.modulos,
                "idPca": this.PCAAtiva.id,
                "modulosAnalise": this.retificacao.modulosAnalise,
                "arquivos": this.retificacao.arquivos
            };

            this.gestaoPcaService.enviarRetificacao(retificacaoNova).subscribe(data => {
                this.mostrarAlerta("", "Retificação enviada com sucesso!");
                this.objetoRetorno.flag = true;
                this.viewCtrl.dismiss(this.objetoRetorno);
            }, error => {
                this.mostrarAlerta("Erro ao enviar a retificação", error.mensagem);
                this.loading = false;
                console.log("erro: " + error);
            });
        }
    }

    limparCamposPortaria() {
        this.retificacao = {
            "idSaneamento": 0,
            "descricao": "",
            "modulos": [],
            "idPca": 0,
            "modulosAnalise": [],
            "arquivos": false
        }
    }

    dismiss() {
        this.objetoRetorno.flag = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    salvar() {

        this.loading = true;

        let retificacaoNova = {
            "idSaneamento": this.idSaneamento,
            "descricao": this.retificacao.descricao,
            "modulos": this.retificacao.modulos,
            "idPca": this.PCAAtiva.id,
            "modulosAnalise": this.retificacao.modulosAnalise,
            "arquivos": this.retificacao.arquivos
        };

        this.gestaoPcaService.salvarRetificacao(retificacaoNova).subscribe(data => {
            this.mostrarAlerta("", "Retificação salva com sucesso!");
            this.loading = false;
        }, error => {
            this.mostrarAlerta("", "Ocorreu um erro ao salvar a retificação. Favor procurar a STI.");
            this.loading = false;
            console.log("erro: " + error);
        });
    }

    mostrarAlerta(titulo, subtitulo) {
        let alert = this.alertCtrl.create({
            title: titulo,
            subTitle: subtitulo,
            buttons: ['Ok']
        });
        alert.present();
    }

    onModuloClose() {

        this.loadingSub = true;

        if (this.comboModulos.length > 0) {
            let modString = this.comboModulos[0].idModuloPca;

            if (this.comboModulos.length > 1) {
                for (let i = 1; i < this.comboModulos.length; i++) {
                    modString += ',' + this.comboModulos[i].idModuloPca;
                }
            }

            this.retificacao.modulos = [];

            for (let i = 0; i < this.comboModulos.length; i++) {
                this.gestaoPcaService.obterModuloPcaPorModuloPorPCA(this.comboModulos[i].idModulo, this.PCAAtiva.id).subscribe(data => {
                    this.retificacao.modulos.push(data);
                    this.carregarRegras(modString);
                }, error => {
                    console.log("erro: " + error);
                });
            }
        } else {
            this.listaSubModulos = [];
            this.loadingSub = false;
            this.loading = false;
        }

    }

    onSubModuloChange(submodulo) {
        this.retificacao.modulosAnalise = submodulo;
    }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-retificacao/modal-retificacao.ts